module.exports = __webpack_public_path__ + "static/media/sologo.007c09b9.png";